<app-navigation>
  <div class="cat-breadcrumbs">Homepage <i class="fa fa-long-arrow-right" aria-hidden="true"></i> {{(pageData$ | async).title}}</div>
</app-navigation>

<section class="content-container">
  <div class="nav-bar">
    <div *ngIf="collapsed">
      <ng-container *ngFor="let navSection of (pageData$ | async)?.pageContent">
        <h3 class="nav-section-tittle" *ngIf="navSection.pageTitle">{{navSection.pageTitle}}</h3>

        <ul class="nav-links-block">
          <li *ngFor="let category of navSection.categories">
            <a class="category" [routerLink]="category.categoriesUrl"
               routerLinkActive="active-link">{{category.categoriesTitle}}</a>
          </li>
        </ul>
      </ng-container>
    </div>

    <button (click)="collapsed = !collapsed">
      <ng-container *ngIf="collapsed">&#x2191;</ng-container>
      <ng-container *ngIf="!collapsed">&#x2193;</ng-container>
    </button>
  </div>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</section>
